module.exports = __webpack_public_path__ + "740dfc521e6006643b008c7ff5212b7a.png";